import { Badge, Button, Checkbox, Hairline } from "@components";

import styles from "@styles/home-configurations.module.scss";

import classNames from "classnames/bind";
import { useEffect, useMemo, useRef, useState } from "react";
import { If } from "shared/components/control-statements";
const css = classNames.bind(styles);

const ProductsSection = ({
  section,
  onChange,
  onSelect,
  onDrop,
  dropdown,
  onAddItems,
  sorting,
  onSortItems,
  onDelete,
  sortingItems,
  onCancelSorting,
  collapsedSection,
  onSelectItem,
  onDeleteItem,
}) => {
  const [collapsed, setCollapsed] = useState(sortingItems || false);

  useEffect(() => {
    if (section.id === collapsedSection) setCollapsed(true);
  }, [section, collapsedSection]);

  const itemsRef = useRef(null);

  useEffect(() => {
    if (!itemsRef.current) itemsRef.current = section.items;
  }, [section.items]);

  const moveItem = (index, direction) => {
    const newIndex = index + direction;

    if (newIndex < 0 || newIndex >= (section.items || []).length) return;

    const newItems = [...section.items];
    const temp = newItems[index];
    newItems[index] = newItems[newIndex];
    newItems[newIndex] = temp;

    onChange({ ...section, items: newItems });
  };

  const builtItems = useMemo(() => {
    const products = (section.items || []).map((item) => {
      return item;
    });

    return products.filter(Boolean);
  }, [section.items]);

  return (
    <div
      className={css({
        section: true,
        collapsed: collapsed,
      })}
      onClick={() => setCollapsed(!collapsed)}
      key={section.id}
    >
      <div className="d-flex align-center justify-between w-100">
        <div className="d-flex align-center gap-20 w-100">
          <If cond={!sorting && !sortingItems}>
            <Checkbox
              checked={section.active}
              value={true}
              onChange={() => {
                onChange({
                  ...section,
                  active: !section.active,
                });
              }}
              disabled={!section.items || section.items.length === 0}
            />
          </If>
          <div className="d-flex align-center justify-between w-100">
            <div className="d-flex flex-column">
              <p className={styles.title}>{section.title}</p>
              <span className={styles.type}>Seção de produtos</span>
            </div>
            <If cond={sortingItems}>
              <div className="d-flex align-center">
                <Button
                  design="primary"
                  className="mr-10"
                  onClick={onCancelSorting}
                >
                  Salvar ordenação
                </Button>
                <Button
                  onClick={() => {
                    onChange({ ...section, items: itemsRef.current });
                    onCancelSorting();
                  }}
                >
                  Cancelar
                </Button>
              </div>
            </If>
          </div>
        </div>

        <If cond={!sorting && !sortingItems}>
          <div className="d-flex align-center">
            <div
              className={styles.dropdown}
              onClick={(e) => {
                onDrop(dropdown === section.id ? null : section.id);
                e.stopPropagation();
              }}
            >
              <div className={styles.action}>
                <i className="fal fa-ellipsis-v" />
              </div>

              <div
                className={css({
                  dropdownOptions: true,
                  in: dropdown === section.id,
                  out: dropdown !== section.id,
                })}
              >
                <ul className={styles.options}>
                  <li onClick={() => onSelect(section)}>Editar</li>
                  <If cond={(section.items || []).length > 0}>
                    <li onClick={() => onSortItems(section)}>Ordenar itens</li>
                  </If>
                  <li onClick={() => onDelete(section)}>Excluir</li>
                </ul>
              </div>
            </div>
            <div className={styles.hairline} />
            <div className={styles.collapse}>
              {collapsed ? (
                <i className="far fa-chevron-up" />
              ) : (
                <i className="far fa-chevron-down" />
              )}
            </div>
          </div>
        </If>
      </div>

      <If cond={collapsed}>
        <If cond={builtItems.length > 0}>
          <Hairline className="mt-15 mb-0" />
          <div className={styles.productsItems}>
            {builtItems.map((item, index) => {
              const { product } = item;
              return (
                <div
                  className={styles.product}
                  key={product.id}
                  onClick={(e) => {
                    e.stopPropagation();
                    onSelectItem(section, product);
                  }}
                >
                  <div className="d-flex align-center justify-between w-100">
                    <div className="d-flex align-center">
                      <div className={styles.image}>
                        <If cond={product.image}>
                          <img
                            src={
                              process.env.REACT_APP_ASSETS_URL +
                              `/` +
                              product.image
                            }
                            alt=""
                          />
                        </If>
                      </div>
                      <div className="d-flex flex-column">
                        <p className={styles.category}>
                          {product.category.name}
                        </p>
                        <p className={styles.name}>{product.name}</p>

                        {item.duplicated && (
                          <span className="d-flex align-center">
                            <Badge name="Duplicado" type="danger" absolute={false} />
                          </span>
                        )}
                      </div>
                    </div>
                    <If cond={item?.unit?.brand?.name || item?.unit?.name}>
                      <div className={styles.brand}>
                        <span>
                          {item?.unit?.brand?.name} - {item?.unit?.name}
                        </span>
                      </div>
                    </If>
                  </div>

                  <If cond={!sortingItems}>
                    <Button
                      design="default-icon-mini"
                      onClick={(e) => {
                        e.stopPropagation();
                        onSelectItem(section, item);
                      }}
                    >
                      <i className="fal fa-pen" />
                    </Button>
                    {/* <Button
                      design="default-icon-mini"
                      onClick={(e) => {
                        e.stopPropagation();
                        onDeleteItem(section, item);
                      }}
                    >
                      <i className="fal fa-trash" />
                    </Button> */}
                  </If>

                  <If cond={sortingItems}>
                    <div className="d-flex align-center gap-10">
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          moveItem(index, 1);
                        }}
                        disabled={index === section?.items.length - 1}
                        type="button"
                        className={styles.moveDown}
                      >
                        <i className="fas fa-chevron-down" />
                      </button>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          moveItem(index, -1);
                        }}
                        disabled={index === 0}
                        type="button"
                        className={styles.moveUp}
                      >
                        <i className="fas fa-chevron-up" />
                      </button>
                    </div>
                  </If>
                </div>
              );
            })}
          </div>
        </If>

        <If cond={!sortingItems}>
          <div className={styles.addContainer}>
            <If cond={builtItems.length === 0}>
              <p>Não existem produtos adicionados à esta seção</p>
            </If>
            <Button design="withIcon" onClick={() => onAddItems(section)}>
              <i className="far fa-plus" /> Adicionar{" "}
              {(section.items || [])?.length > 0 ? "produto" : "produtos"}
            </Button>
          </div>
        </If>
      </If>
    </div>
  );
};

export default ProductsSection;
